// src/jodit-langs/bn.js
window.JoditLang = window.JoditLang || {};
window.JoditLang.bn = {
    'Type something': 'কিছু লিখুন',
    'Bold': 'বোল্ড',
    'Italic': 'ইটালিক',
    'Underline': 'আন্ডারলাইন',
    'Strikethrough': 'কাটা লেখা',
    'Font': 'ফন্ট',
    'Font size': 'ফন্ট সাইজ',
    'Brush': 'রঙ',
    'Background': 'ব্যাকগ্রাউন্ড',
    'Align': 'সাজান',
    'Left': 'বাম',
    'Center': 'মধ্য',
    'Right': 'ডান',
    'Full size': 'পূর্ণ পর্দা',
    'Undo': 'আনডু',
    'Redo': 'রিডু',
    "Insert Link": "লিংক যোগ করুন",
    // जरूरत अनुसार आप और translations जोड़ सकते हैं
};
